import React, { Component } from "react";
import { InputNumber,Modal,Image,Row,Col } from "antd";
import { convertCurrency, convertNumber, replaceVariables } from "./helpers";
import { Button } from "@sunwing/components/dist/Button";
import { Icon } from "@sunwing/components";
import { RCL } from "../../RCL";
import { Loader } from "../../Loader";
import StarCardModal from "../../StarCard/StarCardModal";

class StarBalanceLoadCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSuccessMessage: false,
      submitting: false,
      ServerMessage: "",
      ServerMessageType: "error",
      RedeemLimitationMessage: "",
      pointsToRedeem: this.props.availableBalance,
      isRefetchingData: false,
      isModalOpen:false,
      isOpen:false,
      redeemAmount:0,
    };
  }

  onChange = (value) => {
    let _value = value;

    if (isNaN(_value)) {
      return false;
    }

    if (_value > this.props.availableBalance) {
      _value = this.props.availableBalance;
    }

    this.setState({
      pointsToRedeem: _value,
    });
  };

  closeSuccessMessage = () => {
    // Add Full Screen Blocker (Loader)
    this.setState({
      isRefetchingData: true,
    });
    this.props.handleRefreshData(() => {
      this.setState({
        isRefetchingData: false,
      });
      this.props.handleShowLoadCard();
    });
  };

  toggleModal = () => {    
    this.setState({
      isModalOpen: !this.state.isModalOpen,
    });
  };
 
  setIsOpen = (value) => {    
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  handleLoadSTARCard = (event) => {

    event.preventDefault();
    if (this.state.submitting) return;

    const Cashamount = Math.ceil( this.state.pointsToRedeem * this.props.redemptionRules.PointRate);
    const totalRedeemAmount = this.props.currentDateRedeemTotal + Cashamount;
    const totalBalanceAmount = this.props.STARCashBal + Cashamount;

    if(totalRedeemAmount > 10000 || totalBalanceAmount > 10000){
      this.setState({
        RedeemLimitationMessage: this.props.labels.redeemTotalLimitationMessage,
        submitting: false,
        isModalOpen:true,
      });
      return;
    } else if(Cashamount > 2500){
      this.setState({
        RedeemLimitationMessage: this.props.labels.maximumRedemptionMessgae,
        submitting: false,
        isModalOpen:true,
      });
      return; 
    } else if(this.props.currentDateRedeemCount > 4){
      this.setState({
        RedeemLimitationMessage: this.props.labels.redeemTimesLimitationMessage,
        submitting: false,
        isModalOpen:true,
      });
      return; 
    }

    if(this.props.externalCardHolderId){
      
      this.setState({
        submitting: true,
      });

      const RedeemInfo = {
        AgentGlobalId: this.props.redemptionRules.AgentGlobalId,
        ExternalCardHolderId: this.props.externalCardHolderId,
        Cashamount: Cashamount,
        PointsRedeemed: this.state.pointsToRedeem,
      };

      fetch(this.props.urlPost, {
        headers: {
          Authorization: `Bearer ${this.props.token}`,
          "Content-Type": "application/json",
        },
        method: "PUT",
        body: JSON.stringify(RedeemInfo),
      })
        .then((response) => {        
          if (!response.ok) {         
            throw Error(response.statusText);
          }
          return response.json();
        })
        .then((res) => {        
          if (res) {          
            this.setState({
              ServerMessage: this.props.labels.okStarLoadSuccessful.replace("{0}", this.state.pointsToRedeem).replace("{1}", Cashamount),
              ServerMessageType: "success",
              submitting: true,
            });
          } else {
            this.setState({
              ServerMessage: res.ResponseText,
              ServerMessageType: "error",
              submitting: false,
              isModalOpen:true,
            });
          }
        })
        .catch((error) => {
          this.setState({
            ServerMessage: error.message,
            ServerMessageType: "error",
            submitting: false,
            isModalOpen:true,
          });
      });
    }else {
      const cashAmount = Math.ceil(
        this.state.pointsToRedeem * this.props.redemptionRules.PointRate
      );

       this.setState({
        redeemAmount: cashAmount,
      });

      this.setState({ isOpen: true });
    }
  };

  render() {
    const { locale, labels, availableBalance, redemptionRules, loadStarCardImageUrl, provinces, starAgentInfo, isValidAgencyNumber } = this.props;

    const maxRedemptionPoints =
      redemptionRules.MaxPntsRedeem > availableBalance
        ? availableBalance
        : redemptionRules.MaxPntsRedeem;

    return (
      <>
        {this.state.isRefetchingData && (
          <div className="star-balance__loader">
            <Loader />
          </div>
        )}
        <div className="star-balance__load">
          <p>
            {replaceVariables(
              labels.redemptionRules,
              redemptionRules.PointRate,
              convertNumber(redemptionRules.MinPntsRedeem, locale),
              convertCurrency(
                Math.ceil(
                  redemptionRules.MinPntsRedeem * redemptionRules.PointRate
                ),
                locale
              ),
              convertNumber(redemptionRules.MaxPntsRedeem, locale)
            )}
          </p>
          <p className="star-balance__points">
            <RCL searchKey="star_pointsbalance" /> {availableBalance}
          </p>
          {this.state.ServerMessage.length > 0 && this.state.ServerMessageType === "success" && (
            <div
              className={"alert alert-success"}
              role="alert"
            >
              {this.state.ServerMessage}
            </div>
          )}
          {this.state.ServerMessage.length > 0 && this.state.ServerMessageType === "error" && (             
              <Modal               
               visible={this.state.isModalOpen}              
               onCancel={this.toggleModal}
               footer={false} 
               bodyStyle={{color:"red"}}                                     
              >         
              <div
               className={"alert alert-danger"}
               role="alert"
              >
                <Row gutter={16}>
                  <Col className="gutter-row" span={12}>
                   <RCL searchKey="ZoomPass_Timeout_Error" />
                  </Col>
                  <Col className="gutter-row" span={12}>
                  <Image
                    src={loadStarCardImageUrl}
                    width={200}
                    height={140}
                    preview={false}
                  />                   
                  </Col>
                </Row>                                   
              </div>                       
              </Modal>                       
          )}
          {!this.state.submitting && (
            <div className="star-balance__load-container">
              <div className="star-balance__load-amount">
                <p>
                  <RCL searchKey="star_Pointsredeem" />
                </p>
                <InputNumber
                  min={redemptionRules.MinPntsRedeem}
                  max={maxRedemptionPoints}
                  step={100}
                  value={this.state.pointsToRedeem}
                  onChange={this.onChange}
                />
              </div>
              <div className="star-balance__load-value">
                <p>{labels.cashValue}</p>
                <p className="star-balance__load-cash">
                  {convertCurrency(
                    Math.ceil(
                      this.state.pointsToRedeem * redemptionRules.PointRate
                    ),
                    locale
                  ).replace("$", "")}
                </p>
              </div>
              <div className="star-balance__load-btns">
                <Button
                  type="submit"
                  className="btn btn-primary"                 
                  disabled={
                    !(
                      this.state.pointsToRedeem <= redemptionRules.MaxPntsRedeem
                    ) ||
                    !(
                      this.state.pointsToRedeem >= redemptionRules.MinPntsRedeem
                    ) ||
                    !(this.state.pointsToRedeem <= availableBalance) ||
                    this.state.submitting 
                    || !isValidAgencyNumber
                  }
                  onClick={this.handleLoadSTARCard}
                >
                  {labels.loadYourSTARCard}
                </Button>
                <Button
                  type="submit"
                  outline={true}
                  className="btn btn-primary"
                  onClick={this.props.handleShowLoadCard}
                >
                  <RCL searchKey="star_cancel" />
                </Button>
              </div>
            </div>
          )}
          {!isValidAgencyNumber && (
            <div className="star-balance__error" style={{ color: "red", paddingTop: "1rem" }}>
              <RCL searchKey="invalid_agency_number" />
            </div>
          )}
          {this.state.submitting && (
            <div className="star-balance__success-container">
              <p>
                <Icon name="checked" />
                <RCL searchKey="OK_PointsAdded" />
              </p>
              <Button
                type="button"
                label="close"
                aria-label="close"
                onClick={this.closeSuccessMessage}
              >
                <Icon name="close--n" />
              </Button>
            </div>
          )}
        </div>
        {this.state.isOpen && provinces && 
          <StarCardModal isOpen={this.state.isOpen} setIsOpen={this.setIsOpen} redeemAmount={this.state.redeemAmount} redeemPoints={this.state.pointsToRedeem} starCardData={starAgentInfo} provinceList={provinces} closeSuccessMessage={this.closeSuccessMessage} locale={locale} />}
        {this.state.RedeemLimitationMessage.length > 0 && (             
              <Modal               
               visible={this.state.isModalOpen}              
               onCancel={this.toggleModal}
               footer={false} 
               bodyStyle={{color:"red"}}                                     
              >         
              <div
               className={"alert alert-danger"}
               role="alert"
              >
                <Row gutter={16}>
                  <Col className="gutter-row" span={12}>
                    {this.state.RedeemLimitationMessage}
                  </Col>
                  <Col className="gutter-row" span={12}>
                  <Image
                    src={loadStarCardImageUrl}
                    width={200}
                    height={140}
                    preview={false}
                  />                   
                  </Col>
                </Row>                                   
              </div>                       
              </Modal>                       
          )}
      </>
    );
  }
}

export default StarBalanceLoadCard;
export { StarBalanceLoadCard };
